/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { LocationObject } from './locationObject';
import { OrganizationLink } from './organizationLink';
import { ValidityPeriod } from './validityPeriod';
import { Viewport } from './viewport';

export interface CreateProjectRequest { 
    title: string;
    description: string;
    validity_period: ValidityPeriod;
    website?: string;
    type: string;
    disease_ids: Array<string>;
    funding_source?: string;
    specialty_ids: Array<string>;
    location: LocationObject;
    viewport: Viewport;
    community_id?: string;
    linked_projects?: Array<string>;
    linked_organizations: Array<OrganizationLink>;
}